// src/contexts/ThemeContext.js
import React, { createContext, useContext, useState, useEffect, useCallback, useMemo } from "react";

const ThemeContext = createContext();

export const useTheme = () => useContext(ThemeContext);

/* --- CSS D'ANIMATION MAROCAINE (Déplacé ici pour être global) --- */
const moroccanAnimations = `
@keyframes zellige-shine {
  0%, 100% { box-shadow: 0 0 20px rgba(212, 175, 55, 0.3), 0 0 40px rgba(212, 175, 55, 0.1); }
  50% { box-shadow: 0 0 30px rgba(212, 175, 55, 0.5), 0 0 60px rgba(212, 175, 55, 0.2); }
}
@keyframes moroccan-float {
  0%, 100% { transform: translateY(0px) rotate(0deg); }
  50% { transform: translateY(-10px) rotate(2deg); }
}
@keyframes lantern-swing {
  0%, 100% { transform: rotate(-3deg); }
  50% { transform: rotate(3deg); }
}
@keyframes moroccan-pulse {
  0%, 100% { transform: scale(1); }
  50% { transform: scale(1.05); }
}
@keyframes star-twinkle {
  0%, 100% { opacity: 1; transform: scale(1); }
  50% { opacity: 0.6; transform: scale(0.9); }
}
@keyframes magic-carpet {
  0% { transform: translateY(0) rotate(0deg); }
  25% { transform: translateY(-5px) rotate(1deg); }
  50% { transform: translateY(-8px) rotate(0deg); }
  75% { transform: translateY(-5px) rotate(-1deg); }
  100% { transform: translateY(0) rotate(0deg); }
}
.moroccan-pattern { position: relative; overflow: hidden; }
.zellige-border {
  border: 3px solid;
  border-image: linear-gradient(45deg, #d4af37, #2980b9, #e74c3c, #d4af37) 1;
  animation: zellige-shine 3s ease-in-out infinite;
}
.lantern-effect { animation: lantern-swing 4s ease-in-out infinite; transform-origin: top center; }
.magic-carpet-effect { animation: magic-carpet 6s ease-in-out infinite; }
.star-decoration { animation: star-twinkle 2s ease-in-out infinite; }
.moroccan-hover { transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1); }
.moroccan-hover:hover { transform: translateY(-5px) scale(1.02); box-shadow: 0 20px 40px rgba(212, 175, 55, 0.3) !important; }
`;

export function ThemeProvider({ children }) {
  // 1. État global du thème
  const [darkMode, setDarkMode] = useState(() => {
    const saved = localStorage.getItem("pharmacie-dark-mode");
    return saved === "true";
  });

  // 2. Sauvegarde + classe CSS + attributs globaux sur <html> et <body>
  useEffect(() => {
    localStorage.setItem("pharmacie-dark-mode", darkMode);
    document.body.classList.toggle("dark-mode", darkMode);
    document.documentElement.setAttribute("data-theme", darkMode ? "dark" : "light");
    document.documentElement.classList.toggle("dark-mode", darkMode);
  }, [darkMode]);

  // Appliquer immédiatement au montage (avant le premier rendu)
  useEffect(() => {
    document.body.classList.toggle("dark-mode", darkMode);
    document.documentElement.setAttribute("data-theme", darkMode ? "dark" : "light");
    document.documentElement.classList.toggle("dark-mode", darkMode);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // 3. Injection du CSS globalement
  useEffect(() => {
    const styleId = "moroccan-animations-style";
    if (!document.getElementById(styleId)) {
      const style = document.createElement("style");
      style.id = styleId;
      style.textContent = moroccanAnimations;
      document.head.appendChild(style);
    }
  }, []);

  const toggleTheme = useCallback(() => setDarkMode((prev) => !prev), []);

  const value = useMemo(() => ({ darkMode, isDark: darkMode, toggleTheme }), [darkMode, toggleTheme]);

  return (
    <ThemeContext.Provider value={value}>
      {children}
    </ThemeContext.Provider>
  );
}